var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 59",
    width: 60,
    height: 59,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:4}.b{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m57.5 29.4c0 15.1-12.2 27.3-27.3 27.3-15.1 0-27.3-12.2-27.3-27.3 0-15.1 12.2-27.3 27.3-27.3 15.1 0 27.3 12.2 27.3 27.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m42.6 32.4h-9.2v9.4h-6.4v-9.4h-9.2v-6h9.2v-9.4h6.4v9.4h9.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.6789bfcfeedc65d2b98c02330a756427.svg";
export { ForwardRef as ReactComponent };